<template>
  <div class="service-category-header">
    <div class="title-header-text py-2">
      <div class="row">
        <div class="col-auto col-sm-12">
          <div class="dropdown d-inline-block" v-if="showDropdownForActionBrowse">
            <a
              class="nav-link dropdown-btn px-0"
              data-toggle="dropdown"
              aria-expanded="false"
              href="#" 
            >
              <span class="mr-1 nav-lnk-container">
                {{ platformCategoryName }} Actions:
                <span  v-if="serviceAreas.length==1">{{ currentServiceLine.name }}</span><span v-else>{{ currentServiceArea.name }}</span>
              </span>
              <span class="category-drop-down-arrow down"></span>
            </a>
            <div
              class="dropdown-menu container-fluid category-container"
              aria-labelledby="dropdownMenuButton"
            >
              <div v-if="serviceAreas.length==1">
                <div v-for="serviceLine in serviceAreas[0].serviceLines" :key="serviceLine.id">
                  <router-link
                          @click.native="clickSLRoute(serviceLine)"
                          class="dropdown-item servicearea-dropdown-item"
                          :class="[
                    serviceLine.id === currentServiceLine.id
                      ? 'router-link-active'
                      : ''
                  ]"
                          :to=" {name: 'service-categories-by-id', params: { platformCategory, id : serviceLine.id}}"
                  >{{ serviceLine.name }}</router-link>
                </div>
              </div>
              <div v-else>
              <div v-for="servicearea in serviceAreas" :key="servicearea.id">
                <router-link
                  @click.native="clickSARoute(servicearea)"
                  class="dropdown-item servicearea-dropdown-item"
                  :class="[
                    servicearea.id === currentServiceArea.id
                      ? 'router-link-active'
                      : ''
                  ]"
                  :to=" {name: 'service-categories-by-id', params: { platformCategory, id : servicearea.id}}"
                >{{ servicearea.name }}</router-link>
              </div>
              </div>

            </div>
          </div>
          <div v-else class="d-inline-block">
            <span class="mr-1 nav-lnk-container d-inline-block">
              <span class="nav-link-no-dropdown">{{ platformCategoryName }}
               Actions<span v-if="!isPlatformCategorySameAsServiceLine">: <span  v-if="serviceAreas.length==1">{{ currentServiceLine.name }}</span><span v-else>{{ currentServiceArea.name }}</span>
                </span></span>
            </span>
          </div>
          <employee-hub-bookmark :title="bookmarkTitle" :key="$route.params.id" :env="env" show-circle class="eh-bookmark"></employee-hub-bookmark>
        </div>



      </div>
    </div>
  </div>
</template>

<script>
import { renamePlatformCategory } from "@/utils/componentImportUtils";
import * as CONSTANTS from "@/store/constants";

export default {
  name: "DisplayCategories",
  props: {
    serviceAreas: Array,
    currentServiceArea: Object,
    currentServiceLine: Object,
    platformCategory: String,
    platformCategoryName: String,
    showDropdownForActionBrowse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hrPlatform: CONSTANTS.HR_PLATFORM,
      env: CURRENT_ENV
    }
  },
  computed: {
    isPlatformCategorySameAsServiceLine() {
      return this.currentServiceLine.name.toLowerCase() === this.platformCategoryName.toLowerCase()
    },
    isHRPlatform() {
      return this.platformCategory == this.hrPlatform
    },
    isShowServiceLinesAsCategories() {
          return this.serviceAreas.length == 1
    },
    bookmarkTitle(){
      let bookmarkTitle = this.platformCategoryName + ' Actions'
      bookmarkTitle += this.showDropdownForActionBrowse ? ': ' + this.currentServiceArea.name : ''
      return bookmarkTitle
    }
  },
  methods: {

    clickSARoute(sa) {
      this.$emit("clickSARoute", sa);
    },
    clickSLRoute(sl) {
          this.$emit("clickSLRoute", sl);
    }
  }
};
</script>

<style scoped>
.service-category-header {
  padding-top: 30px;
}

.title-header-text {
  color: #000000;
  font-size: 18px;
}

.nav-lnk-container {
  font-family: artifaktElementBold;
}

.dropdown-btn {
  text-transform: none;
  color: #fff;
  font-size: 38px !important;
  font-weight: bold;
}
.servicearea-dropdown-item {
  padding: 15px 15px 15px 30px;
}

.dropdown-item {
  color: #000000 !important
}

.dropdown-item:hover {
    background: var(--background-color-hover) !important;
    text-decoration: none !important;
}

.category-container .router-link-active {
  color: var(--secondary-color) !important;
  font-weight: bold;
  font-family: artifaktElementBold !important;
}

.category-container {
  z-index: 1001;
}

.category-drop-down-arrow {
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
  background: transparent;
  text-indent: -9999px;
  border-top: 6px solid #000000;
  border-left: 6px solid #000000;
  text-decoration: none;
  color: transparent;
}

.category-drop-down-arrow.down {
  transform: rotate(-135deg);
  margin: 6px;
}
.actions-title-card{
  padding: .5rem 0rem;
}
.nav-link[aria-expanded="true"] .category-drop-down-arrow {
  border-top: 6px solid #000000;
  border-left: 6px solid #000000;
}

.dropdown-menu {
  width: auto;
}
.service-category-header :deep(a:hover){
  color: #000000 !important;
}
@media only screen and (max-width: 400px) {
  .eh-bookmark {
    padding-top: 0px;
    padding-left: 0px;
  }
}
@media (max-width: 851px) {
 .eh-bookmark :deep(.bookmark-icon)[data-v-3a40c1e6] {
    margin-left: 5px;
  }
}

</style>
